import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useKeyPress } from 'shared/hooks/useKeyPress';
import { useIsCopilotStandalonePage } from './useIsCopilotStandalonePage';
interface UseCopilotDrawerKeyboardShortcutsArgs {
  openCopilotDrawer: () => void;
  toggleCopilot: () => void;
  createNewChat: () => void;
  /** When false, shortcuts are not active (e.g. `copilot-sidenav` flag off). */
  enabled?: boolean;
}

/**
 * Copilot sidenav drawer shortcuts:
 * - ⌘/Ctrl+L — toggle the drawer (existing chat)
 * - ⇧⌘/Ctrl+L — open a new chat
 *
 * Registered via {@link useDashboardFrameKeybindings} (dashboard chrome).
 * Composer focus is handled separately by {@link useFocusComposerWhenDrawerOpens}.
 */
export const useCopilotDrawerKeyboardShortcuts = t0 => {
  const $ = _c(9);
  const {
    openCopilotDrawer,
    toggleCopilot,
    createNewChat,
    enabled: t1
  } = t0;
  const enabledProp = t1 === undefined ? true : t1;
  const isOnCopilotStandalonePage = useIsCopilotStandalonePage();
  const enabled = enabledProp && !isOnCopilotStandalonePage;
  let t2;
  if ($[0] !== createNewChat || $[1] !== openCopilotDrawer) {
    t2 = () => {
      createNewChat();
      openCopilotDrawer();
    };
    $[0] = createNewChat;
    $[1] = openCopilotDrawer;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const openNewChat = t2;
  let t3;
  if ($[3] !== enabled || $[4] !== toggleCopilot) {
    t3 = {
      key: "l",
      onPress: toggleCopilot,
      enabled,
      modKey: true,
      shiftKey: false
    };
    $[3] = enabled;
    $[4] = toggleCopilot;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useKeyPress(t3);
  let t4;
  if ($[6] !== enabled || $[7] !== openNewChat) {
    t4 = {
      key: "l",
      onPress: openNewChat,
      enabled,
      modKey: true,
      shiftKey: true
    };
    $[6] = enabled;
    $[7] = openNewChat;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useKeyPress(t4);
};